var _path, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTimeLimitReached = function SvgTimeLimitReached(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "time_limit_reached_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C4C4C4",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#time_limit_reached_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.35 21.5a.731.731 0 0 1-.538-.212.731.731 0 0 1-.212-.538c0-.217.07-.396.212-.538A.731.731 0 0 1 5.35 20h1.3v-3c0-1.05.267-2.025.8-2.925a5.095 5.095 0 0 1 2.175-2.025l-.125-.125a4.919 4.919 0 0 1-1.45-1.15A6.089 6.089 0 0 1 7.075 9.2L1.8 3.925a.72.72 0 0 1-.225-.525c0-.2.075-.383.225-.55a.805.805 0 0 1 .55-.225c.2 0 .383.075.55.225l18.425 18.475c.15.15.229.325.237.525.009.2-.07.375-.237.525a.72.72 0 0 1-.525.225.72.72 0 0 1-.525-.225l-.9-.875H5.35Zm9.325-9.675L13.6 10.75c.667-.333 1.208-.837 1.625-1.512A4.178 4.178 0 0 0 15.85 7V4h-7.7v1.3l-.95-.95V4h-.35l-1.5-1.5h13.3c.217 0 .396.07.538.212a.731.731 0 0 1 .212.538.728.728 0 0 1-.75.75h-1.3v3c0 1-.233 1.925-.7 2.775a5.42 5.42 0 0 1-1.975 2.05ZM8.15 20h7.7v-2.025l-4.9-4.9c-.833.217-1.508.692-2.025 1.425-.517.733-.775 1.567-.775 2.5v3Zm9.2 0h1.025l-1.025-1.05V20Z",
    fill: "#DE4545"
  }))));
};

export default SvgTimeLimitReached;